export const debounce = (func: any, delay: number) => {
  let debounceTimer: NodeJS.Timeout | undefined
  return (...args: any) => {
    clearTimeout(debounceTimer)
    debounceTimer = setTimeout(() => func.call(this, ...args), delay)
  }
}
